var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartnersOpencloser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 17.5C20.25 17.6989 20.171 17.8897 20.0303 18.0303C19.8897 18.171 19.6989 18.25 19.5 18.25L4.5 18.25C4.30109 18.25 4.11032 18.171 3.96967 18.0303C3.82902 17.8897 3.75 17.6989 3.75 17.5C3.75 17.3011 3.82902 17.1103 3.96967 16.9697C4.11032 16.829 4.30109 16.75 4.5 16.75L19.5 16.75C19.6989 16.75 19.8897 16.829 20.0303 16.9697C20.171 17.1103 20.25 17.3011 20.25 17.5ZM20.25 12C20.25 12.1989 20.171 12.3897 20.0303 12.5303C19.8897 12.671 19.6989 12.75 19.5 12.75L4.5 12.75C4.30109 12.75 4.11032 12.671 3.96967 12.5303C3.82902 12.3897 3.75 12.1989 3.75 12C3.75 11.8011 3.82902 11.6103 3.96967 11.4697C4.11032 11.329 4.30109 11.25 4.5 11.25L19.5 11.25C19.6989 11.25 19.8897 11.329 20.0303 11.4697C20.171 11.6103 20.25 11.8011 20.25 12ZM20.25 6.5C20.25 6.69891 20.171 6.88968 20.0303 7.03033C19.8897 7.17098 19.6989 7.25 19.5 7.25L4.5 7.25C4.30109 7.25 4.11032 7.17098 3.96967 7.03033C3.82902 6.88968 3.75 6.69891 3.75 6.5C3.75 6.30109 3.82902 6.11032 3.96967 5.96967C4.11032 5.82902 4.30109 5.75 4.5 5.75L19.5 5.75C19.6989 5.75 19.8897 5.82902 20.0303 5.96967C20.171 6.11032 20.25 6.30109 20.25 6.5Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnersOpencloser);
export default __webpack_public_path__ + "static/media/partners-opencloser.e35738c1b1315efcf0d9eccc73644d4f.svg";
export { ForwardRef as ReactComponent };